import { Link } from 'react-router-dom'
import { CheckCircle2, Leaf } from 'lucide-react'
import { GREEN_BANNER_POINTS } from '../../config/home.config'

export function GreenBanner() {
  return (
    <aside className="w-full lg:w-[280px] shrink-0 rounded-xl overflow-hidden bg-gradient-to-br from-accent-500/15 via-brand-50 to-brand-100 border border-accent-500/30 p-6 relative">
      <div className="absolute top-3 right-3 text-accent-500/60">
        <Leaf className="w-10 h-10" />
      </div>

      <div className="text-brand-700 font-bold text-2xl leading-tight">
        Xe Điện
        <br />
        Cho Cuộc Sống
      </div>
      <div className="text-accent-600 font-extrabold text-4xl mt-1 italic">
        Xanh
      </div>

      <ul className="mt-5 space-y-2.5">
        {GREEN_BANNER_POINTS.map((p) => (
          <li key={p.label} className="flex items-center gap-2 text-sm text-text">
            <CheckCircle2 className="w-4 h-4 text-accent-500 shrink-0" />
            <span>{p.label}</span>
          </li>
        ))}
      </ul>

      <Link
        to="/danh-muc/xe-may-dien"
        className="mt-5 inline-flex items-center justify-center w-full h-11 rounded-full bg-accent-500 hover:bg-accent-600 text-white font-semibold text-sm transition"
      >
        Khám phá ngay
      </Link>
    </aside>
  )
}
